import { ErrorHandler, Injectable } from '@angular/core'
import { MatDialog } from '@angular/material/dialog'

import { AsiakkaanTuote } from '@lemon/core-firebase/model/lasku'

import { firstValueFrom } from 'rxjs'

import { LaskuService } from '../../_angular/service/lasku/lasku.service'
import { LadataanService } from '../../_jaettu-angular/service/ladataan.service'
import { TuoteDialog, TuoteDialogData } from './tuote.dialog'

@Injectable()
export class TuoteDialogiService {
  constructor(
    private _dialog: MatDialog,
    private _laskuService: LaskuService,
    private _ladataanService: LadataanService,
    private _errorHandler: ErrorHandler,
  ) {}

  async avaaTuoterekisterinTuote(tuote: AsiakkaanTuote | null) {
    const data: TuoteDialogData = { tuote }
    const tulos = await firstValueFrom(this._dialog.open<TuoteDialog, TuoteDialogData, AsiakkaanTuote | 'poistettu'>(TuoteDialog, { data, width: '560px' }).afterClosed())
    if (!tulos || tulos === 'poistettu') {
      return
    }

    this._ladataanService.aloitaLataaminen()
    try {
      await this._laskuService.updateTuotteet([tulos])
    } catch (err) {
      this._errorHandler.handleError(err)
    } finally {
      this._ladataanService.lopetaLataaminen()
    }
  }
}
